import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { FilterCard } from 'src/app/models/relatorio';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';
import { environment } from 'src/environments/environment';
import {saveAs} from 'file-saver';
import { FormControl } from '@angular/forms';
import { BooleanConverter } from 'src/app/shared/helpers/converters/boolean-converter';

@Component({
  selector: 'app-situacao-cartao',
  templateUrl: './situacao-cartao.component.html',
  styleUrls: ['./situacao-cartao.component.css']
})
export class SituacaoCartaoComponent implements OnInit {

  constructor(
    private relatorioService: RelatorioService,
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    public datepipe: DatePipe,
    private modalService: NgbModal
  ) { }

  public currentUser: Auth;
  public filtro = new FilterCard(null,null,null);
  public cards: any;
  public filtroOn: boolean = false;
  
  public statusCtrl: FormControl = new FormControl();
  public incDateCtrl: FormControl = new FormControl();
  public panCtrl: FormControl = new FormControl();
  queryDate: Date;

  public mask = [/[1-9]/, /\d/, /\d/, /\d/,' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]
  
  public panMask = ['*','*','*','*',' ','*','*','*','*',' ','*','*','*','*',' ', /[1-9]/, /\d/, /\d/, /\d/]

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    this.filtro.status = 1;
    this.statusCtrl.setValue("1");
    this.filtroOn = true;
    this.carregarRelatorio(1);
  }

  carregarRelatorio(page){
    this.currentPage = page;
    this.relatorioService.getCardStatus(this.currentUser.token.assignorGuid,(page-1),+this.showItem,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.cards = response.result.card;
        this.totalItems = response.result.total;     
        this.queryDate = new Date();        
      }
    });
  }  

  showItemChanged(event) {
    this.showItem = event;
    this.carregarRelatorio(1);
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }
  
  applyFilter() {
    this.filtro.dateInclusion = this.incDateCtrl.value;
    this.filtro.pan = this.panCtrl.value ? this.panCtrl.value.replace(/\*/g,'').replace(/\s/g,'').trim() : null;
    this.filtro.status = this.statusCtrl.value ? +this.statusCtrl.value : null; 

    if(
      this.filtro.dateInclusion == null &&
      (this.filtro.pan == null) &&
      this.filtro.status == null
    ){
      this.filtroOn = false;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    } else {
      this.filtroOn = true;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    }
  }

  deleteFilter(){
    this.filtro.dateInclusion = null;
    this.filtro.pan = null;
    this.filtro.status = null;

    this.incDateCtrl.setValue(null);
    this.panCtrl.setValue(null);
    this.statusCtrl.setValue(null);

    this.filtroOn = false;  
    this.carregarRelatorio(1);
  }
 
  exportExcel(){
  var result = [];
  let date: any = new Date();
  date = date.toLocaleDateString('pt-BR');
  date = date.split('/');

  const excelService = new ExcelService();
  const worksheets = new Array<WorksheetData>();
  const ws = new WorksheetData();
  ws.worksheetTitle = 'situacao_cartao_elo' + date[2] + '-' + date[1] + '-' + date[0];
  ws.worksheetHeaders = ['Número do cartão','Inclusão','Favorecido','Validade','Vinculo','Bloqueio'];
  ws.WorksheetRows = [];
  // /*
  this.relatorioService.getCardStatus(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
  .subscribe(response => {
    if (response.status === ApiError.Sucesso) {
      result = response.result.card;      
    
      result.forEach((r) => {
        const lr = new Array<string>();
        lr.push(r.pan);
        lr.push(this.datepipe.transform(r.inclusionDate, 'dd/MM/yyyy'));
        lr.push(r.collaborator);
        lr.push(r.expirationDate);
        lr.push(r.linked ? 'Vinculado' : 'Não Vinculado');
        if(r.linked && r.definitive){
          lr.push('Definitivo');
        } else if(r.linked && r.actived && !r.definitive){
          lr.push('Ativo');
        } else if(r.linked && !r.actived && !r.definitive){
          lr.push('Temporário');
        } else if (!r.linked){
          lr.push('-');
        }
        ws.WorksheetRows.push(lr);
      });

      worksheets.push(ws);

      // let filter = '';
      // filter += this.filtro.collaboratorsId?.length > 0 ? 'Favorecidos: ' + this.collaboratorsFilterText : ''
      
      excelService.generateExcelReport('Situação de cartões Elo', worksheets, null).xlsx
      .writeBuffer().then((data) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, ws.worksheetTitle + '.xlsx');
      });

    }
  },
  error => {
    this.alertService.error('Ocorreu um erro ao paginar relatorio');
  });
  // */
}

exportPdf(){
  let result = [];
  let date: any = new Date();
  date = date.toLocaleDateString('pt-BR');
  date = date.split('/');

  const pdfData = new PdfData();
  pdfData.PdfTitle = 'situacao_cartao_elo' + date[2] + '-' + date[1] + '-' + date[0];
  pdfData.PdfHeaders = ['Número do cartão','Inclusão','Favorecido','Validade','Vinculo','Bloqueio'];
  pdfData.PdfRows = [];

  this.relatorioService.getCardStatus(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
  .subscribe(response => {
    if (response.status === ApiError.Sucesso) {
      result = response.result.card;       
    
      result.forEach((r) => {
        const lr = new Array<string>();
        lr.push(r.pan);
        lr.push(this.datepipe.transform(r.inclusionDate, 'dd/MM/yyyy'));
        lr.push(r.collaborator);
        lr.push(r.expirationDate);
        lr.push(r.linked ? 'Vinculado' : 'Não Vinculado');
        if(r.linked && r.definitive){
          lr.push('Definitivo');
        } else if(r.linked && r.actived && !r.definitive){
          lr.push('Ativo');
        } else if(r.linked && !r.actived && !r.definitive){
          lr.push('Temporário');
        } else if (!r.linked){
          lr.push('-');
        }
        pdfData.PdfRows.push(lr);
      });

      let filter = '';
      filter += this.filtro.dateInclusion ? 'Data de Inclusão: ' + this.datepipe.transform(this.filtro.dateInclusion, 'dd/MM/yyyy') : ''
      filter += this.filtro.pan ? (filter == '' ? '' : ' - ') + 'Final do cartão: ' + this.filtro.pan : ''
      filter += this.filtro.status ? (filter == '' ? '' : ' - ') + 'Situação: ' + this.filtro.status : ''
      
      const pdfService = new PdfService();
      pdfService.generatePdfReport('Situação de cartões Elo',pdfData,filter,this.datepipe.transform(this.queryDate, 'dd/MM/yyyy HH:mm:ss')).getBlob((blob) => {
        saveAs(blob, pdfData.PdfTitle + '.pdf');
      });

    } else {
      this.alertService.error(response.message);
    }
  },
  error => {
    this.alertService.error(
      'Ocorreu um erro ao paginar o relatorio'
    );
  });
}
}
